import { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddProductForm from "../../components/Seller/AddProductForm";
import Config from "../../Config";
import { useSelector } from "react-redux";
import SellerProductTable from "../../components/Seller/SellerProductTable";
function SellerDashboard() {
  const user = useSelector((state) => state.UserReducer.user);
    
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAddForm, setShowAddForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // Fetch seller's products
  useEffect(() => {
    fetchSellerProducts();
  }, [refreshTrigger]);

  const fetchSellerProducts = async () => {
    setIsLoading(true);
    try {
    //   const token = localStorage.getItem("user");
      
      const response = await fetch(`${Config.apiUrl}/products/seller/my-products`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch products");
      }
    //   console.log('response of SellerDashboard.js >> response >> ', response);

      const data = await response.json();
      setProducts(data.products || data || []);
      toast.success("Products loaded successfully");
    } catch (error) {
      console.error("Error fetching products:", error);
      toast.error("Failed to load products");
    } finally {
      setIsLoading(false);
    }
  };

  const handleProductAdded = () => {
    setShowAddForm(false);
    setRefreshTrigger(prev => prev + 1); // Trigger refresh
    toast.success("Product added successfully!");
  };

  return (
    <DashboardContainer>
      <Header>
        <Title>Seller Dashboard</Title>
        <AddProductButton onClick={() => setShowAddForm(!showAddForm)}>
          {showAddForm ? "Close Form" : "+ Add New Product"}
        </AddProductButton>
      </Header>

      {showAddForm && (
        <AddProductForm
          onProductAdded={handleProductAdded}
          onCancel={() => setShowAddForm(false)}
        />
      )}

      <ContentSection>
        <SectionTitle>My Products</SectionTitle>
        {isLoading ? (
          <LoadingText>Loading products...</LoadingText>
        ) : (
        //   <SellerProductList 
        //     products={products} 
        //     onRefresh={() => setRefreshTrigger(prev => prev + 1)}
        //   />
        <SellerProductTable
        products={products}
        onRefresh={() => setRefreshTrigger(prev => prev + 1)}
        />
        )}
      </ContentSection>
    </DashboardContainer>
  );
}

export default SellerDashboard;


const DashboardContainer = tw.div`
  min-h-screen bg-gray-50 p-3 sm:p-4 md:p-6 lg:p-8
`;

const Header = tw.div`
  flex flex-col sm:flex-row justify-between items-start sm:items-center 
  gap-4 mb-6 sm:mb-8 bg-white p-4 sm:p-5 md:p-6 rounded-xl shadow-sm
`;

const Title = tw.h1`
  text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800
`;

const AddProductButton = tw.button`
  w-full sm:w-auto px-4 sm:px-5 md:px-6 py-2 sm:py-2.5 md:py-3 
  bg-green-600 text-white rounded-lg font-semibold text-sm sm:text-base
  hover:bg-green-700 active:bg-green-800 transition-colors duration-200
  shadow-md hover:shadow-lg
`;

const ContentSection = tw.div`
  bg-white p-4 sm:p-5 md:p-6 rounded-xl shadow-sm
`;

const SectionTitle = tw.h2`
  text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-4 sm:mb-6
`;

const LoadingText = tw.p`
  text-center text-gray-500 py-6 sm:py-8 text-sm sm:text-base
`;